import { getQueryParamByName, getTags, normalizeTags } from "@kaltura/mediaspace-shared-utils";
import { ScheduledSession } from "@kaltura/mediaspace-shared-event-platform-event-list";
import { FiltersValues } from "./bubbles/Bubbles";
import { FilterByTags } from "@kaltura/mediaspace-shared-types";

export const filterSessions = (sessions: ScheduledSession[], keyword: string, selectedFilters: FiltersValues = {}) => {
    return sessions.filter((session) => {
        // session tags as array
        const tags = normalizeTags(getTags(session.tags));
        // session start time label
        const startTime = session.schedulingData.label.toLowerCase();
        // search string - all searchable strings on an entry
        const speakers = session.presenters
            .map((speaker) => speaker.name || "")
            .join(",")
            .toLowerCase();
        const searchString = `${session.name}
                              ${session.description || ""}
                              ${speakers}${session.tags || ""}`.toLowerCase();

        // filter sessions by filters
        const sessionFilters = Object
            .entries(selectedFilters)
            .map(([param, values]) => [param, values.map((value) => value.toLowerCase())]);

        // satisfy every filter
        return (
            sessionFilters.every(
                ([param, values]) =>
                    // tags contain some filter values
                    (param !== "date" && tags.filter(Set.prototype.has, new Set(values)).length > 0)
                    // date match start time
                    || (param === "date" && values.includes(startTime))
            )
            // filter sessions by search input
            && searchString.includes(keyword.toLowerCase())
        );
    });
};

export const getFiltersValuesFromQueryString = (filters: FilterByTags[]) => {
    const filterValues: FiltersValues = {};
    // set filter values from query string
    filters.forEach((filter) => {
        // read filter value from query string
        const param = filter.id;
        const value = getQueryParamByName(param) || "";
        const values = value
            // values are in the form ?param=value1__value_2
            .split("__")
            // `_` replaces space
            .map((tag) => tag.split("_").join(" "))
            // allow only values defined in the filter
            .filter((value) => filter.tags.includes(value));

        if (values.length) {
            filterValues[param] = values;
        }
    });
    return filterValues;
};

export const appendFiltersToQueryString = (param: string, values: string[]) => {
    // Update URL query string
    const searchParams = new URLSearchParams(window.location.search);
    // replace spaces with underscores
    const queryParam = param;

    // Clear or update the parameter in the query string
    if (values.length === 0) {
        searchParams.delete(queryParam);
    }
    else {
        // Replace spaces with underscores and join values with `__`
        const queryValue = values.map((value) => value.split(" ").join("_")).join("__");
        searchParams.set(queryParam, queryValue);
    }

    // Update the browser's URL without reloading the page
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
};

export const removeAllQueryParams = (filters: FilterByTags[]) => {
    const searchParams = new URLSearchParams(window.location.search);

    filters.forEach((filter) => {
        searchParams.delete(filter.id);
    });

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
};
